import { ComponentProps } from "react";
import { textFileTruncate } from "../../../utils/textFileTruncate";
import { twMerge } from "tailwind-merge";

interface FileContainerProps extends ComponentProps<"div"> {
  name: string;
  size: string | number;
  handleClick: () => void;
  type?: "remove" | "download";
  containerClassName?: string;
}

export function getIconByExtension(filename: string) {
  const ext = filename.split(".").pop()?.toLowerCase();

  switch (ext) {
    case "pdf":
      return "/assets/svg/icon-pdf.svg";
    case "xml":
      return "/assets/svg/icon-xml.svg";
    case "jpg":
    case "jpeg":
    case "png":
    case "gif":
      return "/assets/svg/icon-img.svg";
    default:
      return "/assets/svg/doc-icon.svg";
  }
}

export const FileContainer = ({
  handleClick,
  name,
  size,
  type = "remove",
  containerClassName,
}: FileContainerProps) => {
  return (
    <div
      title={name}
      className={twMerge(
        "rounded-sm border border-[#00000029] bg-gray-150 px-4 flex justify-center items-center h-16 gap-12",
        containerClassName,
      )}
    >
      <div className="flex gap-2 items-center">
        <img alt="icone de arquivo" src={getIconByExtension(name)} />
        <div className="flex flex-col text-[12px]">
          <span>{textFileTruncate({ limit: 10, text: name })}</span>
          <span>{size}</span>
        </div>
      </div>
      <img
        onClick={handleClick}
        className="cursor-pointer"
        src={
          type === "remove"
            ? "/assets/svg/icon-trash-red.svg"
            : "/assets/svg/icon-down-blue.svg"
        }
        alt="icone"
      />
    </div>
  );
};
